import { Card, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { Add, FilterAlt } from "@mui/icons-material"
import Table from "../../../components/Table"
import { useEffect, useState } from "react"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages} from "./store/index.js";
import WorkflowStepDependencyFilterDialog from './components/WorkflowStepDependencyFilterDialog.js';

const WorkflowStepDependencyList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.workflowStepDependencyStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.workflowStepDependencyStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.workflowStepDependencyStore?.totalPages);

    const [tableData, setTableData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        stepId: "",
        dependsOnStepId: "",
        dependencyType: ""
    });

    useEffect(() => {
        fetchWorkflowStepDependencyList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchWorkflowStepDependencyList = async () => {
        setCircleLoading(true);
        try {      
        let url = `/reference/orchestration/work-flow-step-dependencies?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.stepId !== "" && filterData.stepId !== null && filterData.stepId !== undefined) {
            url += `&stepId=${filterData.stepId}`;
        }
        if(filterData.dependsOnStepId !== "" && filterData.dependsOnStepId !== null && filterData.dependsOnStepId !== undefined) {
            url += `&dependsOnStepId=${filterData.dependsOnStepId}`;
        }
        if(filterData.dependencyType !== "" && filterData.dependencyType !== null && filterData.dependencyType !== undefined) {
            url += `&dependencyType=${filterData.dependencyType}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setTableData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(
            `/api-engine/key-value-category-delete`,
            {
                ids: [row?.id],
            }
            );
            setIsRefresh(!isRefresh);

            if (response?.success) {
            showSnackbar(response?.message, "success");
            } else {
            showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
    };

    const mappedTable = {
        //table columns
        columns : [
            {
            key: "sno",
            label: "S.No",
            renderCell: (row) => row?.sno,
            },
            {
            key: "stepName",
            label: "Step",
            renderCell: (row) => row?.stepName,
            },
            {
            key: "dependsOnStep",
            label: "Dependent Step",
            renderCell: (row) => row?.dependsOnStep,
            },
            {
            key: "dependencyType",
            label: "Dependent Type",
            renderCell: (row) => row?.dependencyType,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row?.createdAt,
            },
            {
            key: "active",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row?.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            ),
            },
        ],
        //table rows
        rows : tableData.map((item, index) => ({
            ...item,
            sno: index + 1,
            stepId: item?.stepId || "",
            stepName: item?.step?.stepName || "",
            dependsOnStep: item?.dependsOnStep?.stepName || "",
            dependencyType: item?.dependencyType?.keyName || "",
            createdAt: new Date(item.createdAt).toLocaleDateString("en-GB"),
        }))
    };

    const actions = {
        view: true,
        edit: true,
        delete: true,
        onDelete: (row) => handleDelete(row),
        onView: (row) => navigate(`/operation/workflow-step-dependency/step-dependency-details?pageType=view&id=${row.id}`),
        onEdit: (row) => navigate(`/operation/workflow-step-dependency/step-dependency-details?pageType=edit&id=${row.id}`)
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Workflow Step Dependency List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Workflow Step Dependencies.
              </MaterialTypography>
            </Stack>

            <Stack direction="row" spacing={1}>
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt />}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                Filter
                </MaterialButton>
                <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<Add />}
                    onClick={() => navigate("/operation/workflow-step-dependency/step-dependency-details")}
                >
                    Workflow Step Dependency
                </MaterialButton>
            </Stack>
          </Stack>
        }
        />
        <Card sx={{ mx: 1 }}>
            <Table
            columns={mappedTable?.columns}
            data={mappedTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
                }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel={"No Workflow Step Dependency data found"}
            handleSearch={handleSearch}
            />
        </Card>
        <WorkflowStepDependencyFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);
            fetchWorkflowStepDependencyList();
        }}
        />
    </DashboardLayout>
  )
}

export default WorkflowStepDependencyList